module.exports = __webpack_public_path__ + "static/media/FT.93a2ab69.png";